const state = {
  currentAssignmentDetails: undefined
};

export default state;



// WEBPACK FOOTER //
// ./src/store/modules/assignments/state.js